import React, { useState, useEffect,useRef } from 'react';
import './FAQ.css';
import Wave from '../Asset/svgviewer-png-output.png';
import icon1 from '../Asset/Vector 7.png';
import arrowBottom from '../Asset/Arrow 6.png';

const WorkmenCompensationFAQ = () => {
  const [faqs] = useState([
    {
      question: "Q1.Key Benefits of Workmen's Compensation Insurance?",
      answer: (
        <>
         <span style={{ color: "#F37435", fontWeight: "700" }} >• Fulfilling Legal Requirement: </span> Workmen's Compensation Insurance helps employers comply with the legal requirement to provide compensation to employees as per the Workmen's Compensation Act.
         <br></br><span style={{ color: "#F37435", fontWeight: "700" }} >• Financial Protection for Employers: </span> The insurance policy protects the employer's business from the financial burden of high compensation amounts, ensuring the continuity of operations.
         <br></br><span style={{ color: "#F37435", fontWeight: "700" }} > • Financial Security for Employees:</span>  Workmen's Compensation Insurance provides financial security for employees and their families in case of work-related accidents or fatalities, ensuring their well-being.

       </>
      )
    },
    {
      question: "Q2.Documents Required for Workmen's Compensation Insurance Claims",
      answer: (
        <>
        When filing a claim under a Workmen's Compensation Insurance policy, the employee or their dependents need to submit several key documents to support the claim. The required documents vary depending on the nature of the claim, but generally include the following:
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• For All Claims: </span>
          Duly filled and signed claim form Medical certificates related to the injury or disability Compensation records Witness statements (if applicable) Form A (as per the Workmen's Compensation Act)

        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• For Fatal Claims:</span>Death certificate Post-mortem report Proof of dependents (such as marriage certificate, birth certificates of children)

       </>
      )
    },
    {
      question: "Q3.What steps should an employee take after a work-related injury?",
      answer:(
        <>
       <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Notify the Employer: </span>The employee should report the injury to the employer as soon as possible. This can be done by identifying responsible individuals within the organization, such as safety officers or factory inspectors, and providing accurate incident details. It may also be necessary to file a First Information Report (FIR) at the nearest police station depending on the type of injury.
       <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Maintain Records:</span> Employees should maintain detailed records of the accident, including photographs, which can be valuable for safety improvements and the claims process.
      <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Cooperate with Workplace Authorities: </span>Employees should cooperate fully with workplace inspectors, supervisors, or relevant personnel investigating the incident.
      </>
      )
      },

      {
        question: "Q4.Can an employee appeal if their Workmen's Compensation claim is rejected due to a missed deadline? ",
        answer:(
          <>
           Deadlines to file claims vary by state (usually 30-90 days or 1-2 years). File on time whenever possible!


           <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>If your claim is rejected for a missed deadline, you can appeal.</span>
           <br></br>Valid reasons for delay include:
           • Injury prevented you from filing.
           • Employer didn't provide claim forms.
           • You weren't aware of the deadline.
           • Appeal process involves requesting a review and providing justification for the delay.
           A successful appeal means your claim gets processed.Consult a lawyer if your appeal is denied.
        </>
        )
        },
    {
      question: "Q5.Is there a limit on the compensation an employee can receive under Workers' Compensation in India?",
      answer: (
        <>
        While some insurance policies might offer additional benefits, the maximum claim amount for Workers' Compensation in India is mandated by the Employees' Compensation Act (1923). This Act sets the maximum compensation amounts for different types of injuries and disabilities, ensuring a minimum level of financial protection for employees.
        </>
      )
      
    
    },
    {
      question: "Q6.How often should I review my PI insurance coverage?",
      answer: (
        <>
           Workers' Compensation: Safety Net for High-Risk Jobs in India
          The Workers' Compensation Act (1923) protects employees in India performing hazardous work.
          <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Mandatory Insurance for Risky Jobs:</span> Employers in industries like factories, construction, mining, and LPG handling must carry Workers' Compensation Insurance (Schedule II).
         <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Financial Security for Injured Workers:</span>
        This insurance ensures compensation for employees suffering work-related injuries or illnesses, protecting their occupational rights.
        <br></br><span style={{ color: "#F37435", fontWeight: "700" }}>• Expanded Coverage:</span> The Act even covers some seemingly non-hazardous roles like chefs, acknowledging potential risks associated with equipment like gas stoves.
        </>
      )
      
    },
   
   
  ]);

  const [visible, setVisible] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const [selectedFaqIndex, setSelectedFaqIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  const faqContainerRef = useRef(null);

 const toggleVisibility = () => {
    if (window.pageYOffset > 100 && !buttonClicked) {
      setVisible(true);
    } else if (window.pageYOffset <= 100) {
      setVisible(false);
      setButtonClicked(false); // Allow the button to reappear once the user scrolls back to the top
    }
  };

  const scrollToTop = (e) => {
    e.preventDefault(); // Prevent the default anchor click behavior
    console.log(visible); // Log current state
    setVisible(false); // Hide the button immediately when clicked
    setButtonClicked(true); // Mark the button as clicked
  };

  useEffect(() => {
    if (!visible && buttonClicked) {
      console.log(visible); // Log updated state
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [visible, buttonClicked]);

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, [buttonClicked]);



  
  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

//   const handleFaqClick = (index) => {
//     setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
//   };
const handleFaqClick = (index) => {
    if (isMobile) {
      setSelectedFaqIndex(selectedFaqIndex === index ? null : index);
    } else {
      setSelectedFaqIndex(index);
    }
  };
  const handleClickOutside = (event) => {
    if (faqContainerRef.current && !faqContainerRef.current.contains(event.target)) {
      setSelectedFaqIndex(null);
    }
  };

  useEffect(() => {
    if (isMobile) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMobile]);

  return (
    <div>
      <div className='qa-section'>
        <img src={Wave} alt="Wave" className='waveimg' />
        <div ref={faqContainerRef} className={`faq-ct ${isMobile ? 'mobile' : ''}`}>
          <div className="ct box">
            <div className="ct2">
              <h2 style={{ color: "#F37435", fontWeight: "700" }}>FAQ</h2>
              <p style={{ fontSize: "20px", fontWeight: "400", marginTop: '2rem' }}>Frequently Asked Questions</p>
            </div>
            <div className="subct">
              <ul style={{ listStyleType: "none", padding: 0 }}>
                {faqs.map((faq, index) => (
                  <li
                    className={`ct3 ${selectedFaqIndex === index ? "highlighted" : ""} ${isMobile ? "highlighted" : ""}`}
                    key={index}
                    onClick={() => handleFaqClick(index)}
                  >
                    <div className='faq-question'>
                      <strong className='view'>{faq.question}</strong>
                      <img src={icon1} className="side-arrow" alt="sideicon" />
                    </div>
                    {isMobile && (
                      <span className={`arrow ${selectedFaqIndex === index ? "expanded" : ""}`}></span>
                    )}
                    {isMobile && selectedFaqIndex === index && (
                      <div className="subcon1 mobile-subcon">
                        <p>{faq.answer}</p>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {!isMobile && selectedFaqIndex !== null && (
            <div className="con">
              <div className="subcon">
                <p>{faqs[selectedFaqIndex].question}</p>
              </div>
              <div className="subcon1">
                <p>{faqs[selectedFaqIndex].answer}</p>
              </div>
            </div>
          )}
        </div>
        {visible && (
          <a
            href="#"
            id="scroll"
            onClick={scrollToTop}
            // style={styles.scroll}
            
          >
            <img src={arrowBottom} id="arrowsign" alt="Scroll to top"  />
          </a>
        )}
      </div>
    </div>
  );
};

const styles = {
  scroll2: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    right: '5%',
    bottom: '10rem',
    // right: '2%',
    // bottom: '1rem',
    cursor: 'pointer',
    width: '71px',
    height: '71px',
    backgroundColor: 'white',
    borderRadius: '60px',
    zIndex: '1000',
    justifyContent: 'center',
    // boxShadow: '0px 10px 26px rgba(0, 109, 141, 0.2)', 
    boxShadow: '0px 1px 16px rgba(0, 109, 141, 0.25)',
  },
 

  
 span: {
    display: 'block'
  }

};



export default WorkmenCompensationFAQ;